import { useEffect, useRef } from 'react';
import { notification } from 'antd';
import GYAxios from '../../util/GYAxios';

const NoticePopup = () => {
  const shownNoticeRef = useRef(false);
  const shownIdsRef = useRef(new Set());

  useEffect(() => {
    const fetchNotices = async () => {
      if (shownNoticeRef.current) return;
      try {
        const res = await GYAxios.get('/alarms/notice_popup_messages/current-active');

        shownNoticeRef.current = true;
        if (!res.data.success) return;

        const messages = await res.data.data;
        if (!Array.isArray(messages) || messages.length === 0) return;

        messages.forEach((msg) => {
          const id = msg.id ?? JSON.stringify(msg);
          if (shownIdsRef.current.has(id)) return;
          shownIdsRef.current.add(id);

          notification.open({
            key: `notice_${id}`,
            message: msg.title || 'Notice',
            description: msg.message || '',
            placement: 'bottomRight',
            duration: 0, // stay open until user closes
            onClose: () => {
              // keep record of shown messages so they don't reappear automatically
            },
          });
        });
      } catch (e) {
        // fail silently
      }
    };

    const timeout = setTimeout(() => {
      fetchNotices();
    }, 3000);
    return () => clearTimeout(timeout);

  }, []);

  return null;
};

export default NoticePopup;